export const getLayoutPath = (pathname: string) => {
    if (typeof pathname !== 'string' || !pathname.startsWith('/') || pathname === '/') {
        return '/';
    }

    const pathParts = pathname.split('/').filter(Boolean);
    const parts = pathParts[0] === 'mano' ? 2 : 1;

    return '/' + pathParts.slice(0, parts).join('/');
};
